import { Injectable } from '@angular/core';
import { ModalService } from '../modal.service';
import {
    CreateEstablishmentComponent,
} from '../../components/establishments/modals/create-establishment/create-establishment.component';
import {
    EditEstablishmentComponent,
} from '../../components/establishments/modals/edit-establishment/edit-establishment.component';
import { DialogComponent } from '../../../shared/components/dialog/dialog.component';
import { EstablishmentService } from './establishment.service';
import { Establishment } from '../../../../../graphql/generated';

@Injectable({
    providedIn: 'root',
})
export class EstablishmentActionService {

    deleteDialogs: Partial<DialogComponent>[] = [
        {
            title: 'Danger',
            message: 'Deleting your establishments will remove all data linked to this establishments',
            confirmText: 'I understand',
            variant: 'danger',
        },
        {
            title: 'Danger',
            message: 'Are your really sure? This action cannot be undone',
            confirmText: 'Yes, delete my establishments',
            variant: 'danger',
        },
    ];

    constructor(
        private readonly modalService: ModalService,
        private readonly establishmentService: EstablishmentService,
    ) {
    }

    createEstablishment() {
        this.modalService.push(CreateEstablishmentComponent, {
            size: '3xl',
        });
    }

    editEstablishment(establishment: Establishment) {
        this.modalService.push(EditEstablishmentComponent, {
            size: '3xl',
            onInit({ component }) {
                component.establishment = establishment;
            },
        });
    }

    public deleteEstablishment(id: string) {
        this.showDialog(id);
    }

    private showDialog(id: string, index = 0) {
        this.modalService.push(DialogComponent, {
            onInit: ({ component, close }) => {
                Object.assign(component, this.deleteDialogs[index]);

                component.confirm.subscribe(() => {
                    close();
                    if (index < this.deleteDialogs.length - 1) {
                        this.showDialog(id, index + 1);
                    } else {
                        this.establishmentService.delete(id).subscribe();
                    }
                });

                component.cancelled.subscribe(close);
            },
        });
    }

}
